//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NarBar from './component/NavBar.vue'
import {parseTime} from '../../util/index'

export default {
    components:{
        NarBar
    },
    data(){
        return{
            type_option:[
                { text: '全部', value: -1, },
                { text: '已分配', value: 1, num:0 },
                { text: '未分配', value: 0, num:0 },
            ],
            tabList:[
              { text: '全部任务', value: -1 },
            ],
            tab_id:'',
            distribution_type:'',
            search:'',
            orders:{
              orderBy:'',
              sort:'',
            },
            filterData:{
                is_urgent:'',
                status:'',
                start_time:[],
                end_time:[],
                scheduled_start_time:[],
                scheduled_end_time:[],
                remark:'',
              },
            // 图片路径
            imgUrl:'https://hfb.oss-cn-hangzhou.aliyuncs.com/',
            listData:[],
            loading: false,
            page:1,// 列表页数
            total:'', // 全部个数
            finished: false, // 是否全部加载完成
            refreshing: false, // 加载状态
            // 分配
            show_Distribution:false,
            searchUser:'',
            userList:[],
            allRadio:false,
            checkedList:[],
            process_id:'',
            work_order_id:'',
            work_order_item_id:'',

            // 批量
            isBatch:false,
            batchText:'批量报工',
            showPopover:false,
            actions: [
              { text: '开始', icon: 'play-circle-o' },
              { text: '报工', icon: 'records' },
              { text: '结束', icon: 'stop-circle-o' },
            ],
            show_batch:false,
            batchFrom:{
              personnel_name:'',
              personnel_id:'',
              text:'剩余未报工数量',
              startime:'',
              endtime:'',
              workDataTime:'',
              price_type:1,
              unit_price:'',
              approval_type:1,
            },
            output_time_hour :0,
            output_time_min : 0,
            actvied_id:[],

            // 时间
            time:false,
            timeTitle:'选择时间',
            actvied_t:'',
            minDate: new Date(2018, 0, 1),
            maxDate: new Date(2030, 10, 1),
            currentDate: new Date(),
            // 生产人员
            user:false,

            // 权限
            permissions:false,
        }
    },
    mounted(){
      let role = sessionStorage.getItem('role')
      if(role == 1){  //系统管理员
        this.permissions = true
      }else if(role == 2){  // 管理员
        this.permissions = true
      }else{  // 生产人员
        this.permissions = false
      }
      // 获取tab列表
      this.$post('/app/Order/getProjectSelect',{config_target: "Task"}).then(res => {
        res.forEach(item => {
          this.tabList.push({text:item.config_name,value:item.id})
        })
        // console.log(this.tabList);
      })
    },
    methods:{
        onLoad() {
            // 异步更新数据
            if (this.refreshing) {
              this.listData = [];
              this.page = 1
              this.refreshing = false;
            }
            let {is_urgent,status,start_time,end_time,scheduled_start_time,scheduled_end_time,remark} = this.filterData
            let project_id = this.tab_id == -1 ? '' :  this.tab_id 
            let data = {
              page:this.page,
              distribution_type:this.distribution_type,
              search:this.search,
              orders:this.orders,
              is_urgent,
              status,
              start_time,
              end_time,
              scheduled_start_time,
              scheduled_end_time,
              remark,
              project_id
            }
            this.$post('/app/Order/getTaskList',data).then(res => {
              this.page++
              this.total = res.total
              this.type_option[1].num = res.is_distribution
              this.type_option[2].num = res.is_not_distribution

              for (let i = 0; i < res.data.length; i++) {
                res.data[i].isActived = false
                res.data[i].scheduled_time = parseTime(res.data[i].scheduled_start_time,'{y}-{m}-{d}') + '~' + parseTime(res.data[i].scheduled_end_time,'{y}-{m}-{d}')
                res.data[i].permissions = JSON.parse(res.data[i].permissions)
                let distribution_list_text = ''
                res.data[i].distribution_list.forEach(item => {
                  distribution_list_text += item.name + ','
                })
                res.data[i].distribution_list_text = distribution_list_text
                this.listData.push(res.data[i]);
              }

              // 加载状态结束
              this.loading = false;
              // 数据全部加载完成
              if (this.listData.length >= this.total) {
                this.finished = true;
              }

              console.log(this.listData);
            })
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.onLoad();
        },
        // 状态切换
        changeType(i){
          if(i == -1){
            this.distribution_type = ''
          }else{
            this.distribution_type = i
          }
          this.refreshing = true
          this.onRefresh()
        },
        // tab列表切换
        tabChange(value){
          this.tab_id = value
          this.refreshing = true
          this.onRefresh()
        },
        //搜索
        onSearch(value){
          this.search = value
          this.refreshing = true
          this.onRefresh()
        },
        // 排序
        changeOrders(orders){
          console.log(orders);
          this.orders = orders
          this.refreshing = true
          this.onRefresh()
        },
        saveFilterData(filterDate){
          this.filterData.is_urgent = filterDate.is_urgent
          this.filterData.status = filterDate.status
          this.filterData.start_time = filterDate.start_time
          this.filterData.end_time = filterDate.end_time
          this.filterData.scheduled_start_time = filterDate.scheduled_start_time
          this.filterData.scheduled_end_time = filterDate.scheduled_end_time
          this.filterData.remark = filterDate.remark

          this.refreshing = true
          this.onRefresh()
        },

        
        // 获取生产人员
        getUserSelect(){
            let data = {
                name:this.searchUser,
                status:1,
            }
            this.$post('/app/user/getUserSelect',data).then(res => {
                this.userList = res
            })
        },
        // 分配点击
        onDistribution(index){
            this.checkedList = []
            this.process_id = this.listData[index].process_id
            this.work_order_id = this.listData[index].work_order_id
            this.work_order_item_id = this.listData[index].id
            this.getUserSelect()
            this.show_Distribution = true
        },
        // 分配保存
        onDistributionSave(){
          let data = {
            process_id:this.process_id,
            work_order_id:this.work_order_id,
            work_order_item_id:this.work_order_item_id,
            user_id:this.checkedList,
          }
          this.$post('/app/order/setDistribution',data).then(res => {
            this.$toast.success('分配完成!');
            this.refreshing = true
            this.onRefresh()
          })
          this.show_Distribution = false
        },
        // 全选员工按钮
        AllCheckbox(){
            this.checkedList = []
            if(this.allRadio){
                this.userList.forEach(item => {
                    this.checkedList.push(item.id)
                })
            }
        },


        // 批量报工
        onBatch(){
          if(!this.permissions){
            this.$toast('该角色无权限!')
            return
          }

          this.isBatch = !this.isBatch
          if(this.isBatch){
            this.batchText = '取消操作'
          }else{
            this.batchText = '批量报工'
          }
        },

        // 任务点击
        onClickItem(id){
          if(this.isBatch){
            this.listData.forEach(item => {
              if(item.id == id){
                item.isActived = !item.isActived
              }
            })
          }else{
            this.toDetails(id)  
          } 
        },

        // 选项点击
        batchSelect(item,index){
          let actviedList = this.listData.filter(item => {
            return item.isActived == true
          })
          if(actviedList.length <= 0){
            this.$toast('请选择任务项！')
            return 
          }

          this.actvied_id = []
          actviedList.forEach(item =>  {
            this.actvied_id.push(item.id)
          })

          if(index == 0){ // 开始
            this.batchStatus(1)
          }else if(index == 1){  // 报工
            this.batchFrom.personnel_name = ''
            this.batchFrom.personnel_id = ''
            this.batchFrom.price_type = 1
            this.batchFrom.unit_price = ''
            // 当前时间 整时
            let date_one = parseTime(new Date(),'{y}-{m}-{d}')
            let date_two = parseTime(new Date(),'{h}') + ':00:00'
            this.batchFrom.startime = parseTime(this.$SET_DATE(date_one + ' ' + date_two))
            this.batchFrom.endtime = parseTime(this.$SET_DATE(date_one + ' ' + date_two))
            this.output_time_hour = 0
            this.output_time_min = 0
            this.batchFrom.workDataTime = this.output_time_hour + '小时' + this.output_time_min + '分钟'

            this.show_batch = true
          }else if(index == 2){  // 结束
            this.batchStatus(2)
          }
        },

        // 批量修改状态
        batchStatus(i){
          let data = {
              id:this.actvied_id,
              status:i,
            }
            this.$post('/app/order/setTaskStatus',data).then(res => {
              this.$toast.success('操作完成!');
              this.onBatch()
              
              setTimeout(() => {
                this.refreshing = true
                this.onRefresh()
              }, 800);
            })
        },

        // 时间选择
        getTime(i){
            if(i == 1){
               this.timeTitle = '开始时间' 
               this.currentDate = this.$SET_DATE(this.batchFrom.startime)
            }else{
                this.timeTitle = '结束时间' 
                this.currentDate = this.$SET_DATE(this.batchFrom.endtime)
            }
            this.actvied_t = i 
            this.time = true
        },
        confirm(value){
            const t = this.actvied_t  
            if(t == 1){
                this.batchFrom.startime =  parseTime(value)
            }else{
                this.batchFrom.endtime =  parseTime(value)
            }
            let start_time = this.$SET_DATE(this.batchFrom.startime).getTime()
            let end_time = this.$SET_DATE(this.batchFrom.endtime).getTime()
            let timeNumber = (end_time - start_time ) / 1000
            let hour = Math.floor(timeNumber / 3600) 
            let min = 0
            if(hour > 0){
                min = Math.round((timeNumber - hour * 3600) / 60)
            }else{
                min = Math.round(timeNumber / 60) 
            }

            if(min == 60){ // 四舍五入 60 分钟问题
                hour = hour + 1
                min = 0
            }
            
            this.output_time_hour = hour
            this.output_time_min = min
            this.batchFrom.workDataTime = this.output_time_hour + '小时' + this.output_time_min + '分钟'

            this.time = false
        },
        cancel(){
          this.time = false
        },

        // 计价方式切换
        changePrcieType(i){
          this.batchFrom.price_type = i
        },
        // 审批切换
        changeStatus(i){
          this.batchFrom.approval_type = i
        },

        // 生产人员选择
        getUser(){
            this.getUserSelect()
            this.user = true
        },
        // 员工搜索
        onSearchUser(){
            this.getUserSelect()
        },
        setUser(user){
            this.batchFrom.personnel_name = user.name
            this.batchFrom.personnel_id = user.id
        },

        // 批量报工 - 取消
        batchCancel(){
          this.show_batch = false
        },
        // 批量报工 - 确认
        batchConfirm(){
          let start_time = this.$SET_DATE(this.batchFrom.startime)
          let end_time = this.$SET_DATE(this.batchFrom.endtime)
          let data = {
            id:this.actvied_id,
            personnel_id:this.batchFrom.personnel_id,
            start_time:new Date(start_time).getTime() / 1000,
            end_time:new Date(end_time).getTime() / 1000,
            output_time_hour:this.output_time_hour,
            output_time_min:this.output_time_min,
            price_type:this.batchFrom.price_type,
            unit_price:this.batchFrom.unit_price,
            approval_type:this.batchFrom.approval_type
          }
          console.log(data);
          this.$post('/app/order/setBatchOutput',data).then(res => {
            this.$toast.success('操作完成!');
            this.show_batch = false
            this.onBatch()

            setTimeout(() => {
                this.refreshing = true
                this.onRefresh()
            }, 800);
          })
        },
        

        // 前往详情页
        toDetails(id){
          this.$router.push({
              path:'/TaskDetails',
              query:{id:id}
          })
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/home/two.vue